/**
 * パスワードバリデーション関連の定数
 */

// パスワードで使用可能な記号セット
export const ALLOWED_PASSWORD_SYMBOLS = '!@#$%^&*(),.?":{}|<>~_-+=';

// パスワードの最小長
export const PASSWORD_MIN_LENGTH = 8;

// パスワードの最大長
export const PASSWORD_MAX_LENGTH = 128;

/**
 * パスワード記号の正規表現パターンを生成
 * ハイフンを最後に配置することでエスケープを回避
 */
export const createPasswordSymbolPattern = () => {
  // ハイフンを最後に移動してエスケープを回避
  const symbols = ALLOWED_PASSWORD_SYMBOLS.replace('-', '') + '-';
  return `[${symbols}]`;
};

/**
 * フル パスワードバリデーション正規表現パターンを生成
 */
export const createPasswordValidationPattern = () => {
  const symbolPattern = createPasswordSymbolPattern();
  const allowedChars = `A-Za-z\\d${ALLOWED_PASSWORD_SYMBOLS.replace('-', '\\-')}`;
  
  return `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*${symbolPattern})[${allowedChars}]{${PASSWORD_MIN_LENGTH},${PASSWORD_MAX_LENGTH}}$`;
}; 